import React, { useState, useEffect, useRef, useCallback, useMemo } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePlp } from '~/contexts/PlpContext'
import { notBlank, imgSize } from '~/utils/helpers'
import useFilterHook from "~/utils/use-filtering"

import { IconChevLeft, IconChevRight } from '~/components/icons/chevrons'

import { aria_btn } from "~/styles/app.module.scss"
import { arrowbtn } from "~/styles/pages/factory.module.scss"
import * as styles from "~/styles/plp/plp_groupsnav.module.scss"
import * as swtch from "~/styles/shared/undrtoggle.module.scss"

const GroupNav = () => {
  const { locate } = useTheme()
  const { filter_stores } = useFilterHook()
  const { 
    collection, plpHook, currGrpId, currGroup, setCurrGroup, onGroup, featIds
  } = usePlp()

  const { checkStoreGend } = plpHook

  const storeGendConflct = useMemo(() => {
    return checkStoreGend({ locate })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locate])

  const { prods_grouped, group_blockers } = collection
  const { shw_grpnav } = collection.rules || {}

  const [didLoad, setDidLoad] = useState(false)
  const [currGroups, setCurrGroups] = useState(collection.initGroupNav)
  const [total, setTotal] = useState(0)
  const [pos, setPos] = useState(0)
  const [backon, setBackon] = useState(false)
  const [forwon, setForwon] = useState(true)

  const wrapRef = useRef(null)
  const slideRef = useRef(null)
  
  const is_switch = (shw_grpnav && shw_grpnav.length > 1) || false

  const handleBack = () => {
    const inview = arrow_inview()
    let new_pos = inview[0] - 1 - inview.length
    if (new_pos < 0) new_pos = 0

    setPos(new_pos)
  }
  const handleForward = () => {
    const inview = arrow_inview()
    let new_pos 
    if (inview.length) {
      new_pos = inview[inview.length - 1] + 1
      if (new_pos + inview.length >= total) new_pos = total
      if (pos === total) new_pos = 0
    } else {
      new_pos = total
    }
    if (!slideRef.current) {
      const arr = Array.from(document.querySelectorAll(`.${styles.group_btn}`))
      slideRef.current = arr[new_pos - 1]
    }

    setPos(new_pos)
  }

  const arrow_inview = () => {
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const arr = Array.from(document.querySelectorAll(`.${styles.group_btn}`))

    let inview = []
    arr.forEach((x, index) => {
      const el = x.getBoundingClientRect()
      const el_left = el.left - wrap_rect.left 
      const el_right = el.left + el.width - wrap_rect.left - 20
      if (el_left >= 0 && el_right < wrap_rect.width) inview.push(index)
    })
    return inview
  }

  const deskChange = useCallback(() => {
    const arr = Array.from(document.querySelectorAll(`.${styles.group_btn}`))
    if (arr.length < 1) return
    const wrap = wrapRef.current
    const wrap_rect = wrap.getBoundingClientRect()
    const curr_scroll = wrap.scrollLeft

    const next_ind = pos === arr.length ? arr.length - 1 : pos
    const next = arr[next_ind].getBoundingClientRect()
    const next_scroll = next.left + (curr_scroll - wrap_rect.left) - 10

    wrap.scrollTo({
      top: 0,
      left: next_scroll,
      behavior: 'smooth'
    });
  }, [pos])

  const checkScroll = () => {
    const wrap = wrapRef.current
    const max_scrll = Math.round(wrap.scrollWidth - wrap.getBoundingClientRect().width) - 1
    
    const new_back = wrap.scrollLeft >= 5
    if (new_back !== backon) setBackon(new_back)

    const new_forw = wrap.scrollLeft <= max_scrll
    if (new_forw !== forwon) setForwon(new_forw)
  }

  useEffect(() => {
    deskChange()
    
  }, [pos, slideRef, deskChange])

  useEffect(() => {
    const el = wrapRef.current

    if ( el ) {
      el.addEventListener('scroll', checkScroll, { passive: true })
      return () => {
        el.removeEventListener('scroll', checkScroll)
      }
    }
  })

  const colorways = (grp_data) => {
    let item = prods_grouped.find(x => x.mid === grp_data.mid)
    return item?.products?.length || 0
  }

  const get_group_name = () => {
    const def_name = currGroup.toUpperCase()
    if (!currGroups) return ''
    if (!currGrpId) return `SHOP BY ${def_name}`
    const obj = currGroups.find(x => x.mid === currGrpId)
    return `${obj.data.name.split('--')[0]} STYLES`
  }

  const get_groups = () => {
    if (!currGroup) return false

    const group_name = currGroup.includes('group') ? currGroup : `group${currGroup}`
    let group_objs = collection.groups.filter(x => x.type === group_name)
    group_objs = group_objs.filter(x => !group_blockers.includes(x.mid) && notBlank(x.data.image) )
    group_objs = group_objs.filter(x => !!x)

    group_objs.forEach(grp => {
      if (!grp || !grp.hasOwnProperty('products')) return
      const prod_cnt = grp.products.filter(x => x.pl_pima !== 99998).length
      grp.data['count'] = prod_cnt
    })

    if (featIds) {
      const feat_group = group_objs.find(grp => grp.products.find(x => featIds.includes(x.mid)))
      if (feat_group) {
        group_objs = group_objs.filter(x => x.mid !== feat_group.mid)
        group_objs.unshift(feat_group)
      }
    }

    group_objs = filter_stores(group_objs,false,collection.gender,storeGendConflct)

    return group_objs
  }

  const checkFit = () => {
    if (!currGroups || currGroups.length > 4) return ''
    return styles.fill_space
  }

  useEffect(() => {
    if (!currGroup) return
    if (!didLoad) {
      setDidLoad(true)
      return
    }

    const new_groups = get_groups()
    if (new_groups.length < 1) return
    const new_total = new_groups.length

    setTotal(new_total)
    setCurrGroups(new_groups)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currGroup, locate, featIds])
  
  return (
    <div className={styles.gnav_wr} gnav=''>
      <div className={styles.gnav_cont}>
        <div className={styles.head}>
          {!is_switch ? (
            <div className={styles.titlea}>
              {get_group_name()}
            </div>
          ) : (
            <div className={styles.titlea}>
              <div className={swtch.swtch_label}>
                Shop By
              </div>
              <div className={swtch.swtch_btns}>
                {shw_grpnav.map((name,index) => 
                  <button 
                    type="button"
                    key={`swtch${name}${index}`}
                    className={[aria_btn, swtch.swtch_btn].join(' ')} 
                    onClick={(e) => setCurrGroup(name)}
                    aria-current={currGroup === name ? 'true' : 'false'}
                  >
                    {name}
                  </button>
                )}
              </div>
            </div>
          )}
          {!checkFit() && (
            <div className={styles.head_btns}>
              <button 
                type="button"
                className={`${aria_btn} ${arrowbtn} ${styles.dsk_arrowbtn} ${backon ? '' : styles.off}`}
                aria-label="Scroll Back" 
                onClick={(e)=>{handleBack()}}
              >
                <IconChevLeft icon_classes="" />
              </button>
              <button 
                type="button"
                className={`${aria_btn} ${arrowbtn} ${styles.dsk_arrowbtn} ${styles.forw}`}
                aria-label="Scroll Forward" 
                onClick={(e)=>{handleForward()}}
              >
                <IconChevRight icon_classes="" />
              </button>
            </div>
          )}
        </div>
        <div className={[styles.gnav_groups, checkFit()].join(' ')} ref={wrapRef}>
          <div className={styles.groups}>
            {currGroups && currGroups.map( (item, index) =>
              <button 
                type="button"
                key={item.data.name} 
                className={`${aria_btn} ${styles.group_btn}`} 
                aria-pressed={currGrpId === item.mid ? 'true' : 'false'}
                onClick={(e)=> onGroup(item.mid)}
                ref={pos === index ? slideRef : undefined}
              > 
                {(item.data.image) && (
                  <div className={styles.image}>
                    <img src={imgSize(item.data.image,650)} alt={`Detail of the ${item.data.name.split('--')[0]} fabric group`} />
                  </div>
                )}
                <div className={styles.cont}>
                  <div className={styles.title}>{item.data.name.split('--')[0]}</div>
                  <div className={styles.count}>
                    {colorways(item)} PRODUCT{colorways(item) > 1 ? 'S' : ''}
                  </div>
                  {notBlank(item.data.bullets) ? (
                    <div className={styles.bullets} dangerouslySetInnerHTML={{ __html: item.data.bullets }} />
                  ) : (
                    <div className={styles.desc}>{item.data.description}</div>
                  )}
                </div>
              </button>
            )}
          </div>
        </div>
        <button 
          type="button"
          className={`${aria_btn} ${arrowbtn} ${styles.mob_arrowbtn} ${backon ? '' : styles.off}`}
          aria-label="Scroll Back" 
          onClick={(e)=>{handleBack()}}
        >
          <IconChevLeft icon_classes="" />
        </button>
        <button 
          type="button"
          className={`${aria_btn} ${arrowbtn} ${styles.mob_arrowbtn} ${styles.forw}`}
          aria-label="Scroll Forward" 
          onClick={(e)=>{handleForward()}}
        >
          <IconChevRight icon_classes="" />
        </button>
      </div>
    </div>
  )
}

export default GroupNav




